import React from 'react';
import HeaderLink from '../HeaderLink'

import DropDownBtn from '../DropDownBtn'

const Nav = (({ links , isActive, dropdownOnClick,withChildren})=>(
	<nav>
		<div>
			{
				links && links ? links.map((link,i)=>(
					<div className="button" key={link.id}>
					{
						link && link.children !== undefined ? (
							<DropDownBtn {...link} onClick={dropdownOnClick} isActive={ isActive[i].isActive } />
						): <HeaderLink url={link.link.url} text={link.link.caption} target={link.link.target} key={link.id}  className="" isActive={link.isActive}/> 
					}
					{
						withChildren && withChildren && link.children !== undefined ? link.children.map((link)=>(
							<HeaderLink url={link.url} text={link.caption} target={link.target} key={link.id}  className="child" isActive={link.isActive} /> 
						)): ''
					}
					</div>
				)): ''
			}
		</div>
	</nav>
))
export default Nav


// WEBPACK FOOTER //
// ./src/Components/Nav/index.js